import _ from 'lodash';
import { animateScroll } from 'react-scroll';
import { browserHistory } from 'react-router';
import {
  SITE_PLATFORM_WEB_LARGE,
  SITE_PLATFORM_WEB,
  SITE_PLATFORM_TABLET,
  SITE_PLATFORM_MOBILE,
} from 'helpers/BreakpointHelper';
import { helperGetBaseUrlSlug, cleanString } from 'helpers/RouteHelper';

export const OVERLAY_SHOWS_FILTER = 'OVERLAY_SHOWS_FILTER';
const OVERLAY_MOVIES_FILTER = 'OVERLAY_MOVIES_FILTER';
export const OVERLAY_ACCOUNT = 'OVERLAY_ACCOUNT';
export const OVERLAY_HEADER_SEARCH = 'OVERLAY_HEADER_SEARCH';
export const OVERLAY_HEADER_DROPDOWN = 'OVERLAY_HEADER_DROPDOWN';
const OVERLAY_SEARCH_FILTER = 'OVERLAY_SEARCH_FILTER';
const OVERLAY_SHOW_DETAIL_TABS = 'OVERLAY_SHOW_DETAIL_TABS';
const OVERLAY_AUTH_MVPD_DIRECT_SIGN_IN_REDIRECT = 'OVERLAY_AUTH_MVPD_DIRECT_SIGN_IN_REDIRECT';
export const OVERLAY_AUTH_MVPD_START = 'OVERLAY_AUTH_MVPD_START';
const OVERLAY_AUTH_MVPD_SEARCH = 'OVERLAY_AUTH_MVPD_SEARCH';
const OVERLAY_AUTH_SUCCESS = 'OVERLAY_AUTH_MVPD_SUCCESS';
const OVERLAY_AUTH_MVPD_IFRAME = 'OVERLAY_AUTH_MVPD_IFRAME';
const OVERLAY_AUTH_UPSELL_CONFIRM = 'OVERLAY_AUTH_UPSELL_CONFIRM';
const OVERLAY_AUTH_UPSELL_ERROR = 'OVERLAY_AUTH_UPSELL_ERROR';
export const OVERLAY_ALL_COLLECTIONS = 'OVERLAY_ALL_COLLECTIONS';
export const OVERLAY_SHOW_SEASONS_TAB = 'OVERLAY_SHOW_SEASONS_TAB';
export const OVERLAY_SHOW_CLIPS_TAB = 'OVERLAY_SHOW_CLIPS_TAB';
export const OVERLAY_SHOW_MORE_TAB = 'OVERLAY_SHOW_MORE_TAB';
export const OVERLAY_LIVE_DATES = 'OVERLAY_LIVE_DATES';
export const OVERLAY_LIVE_NETWORKS = 'OVERLAY_LIVE_NETWORKS';
export const OVERLAY_LIVE_CTA_OVERFLOW = 'OVERLAY_LIVE_CTA_OVERFLOW';
export const OVERLAY_PRIMETIME_DATES = 'OVERLAY_PRIMETIME_DATES';
const OVERLAY_HOME_CTA_OVERFLOW = 'OVERLAY_HOME_CTA_OVERFLOW';
export const OVERLAY_VIDEO_MODAL = 'OVERLAY_VIDEO_MODAL';
const OVERLAY_UPCOMING_DETAIL = 'OVERLAY_UPCOMING_DETAIL';

export const OVERLAY_BREAKPOINTS = {
  [SITE_PLATFORM_WEB_LARGE]: [
    OVERLAY_ACCOUNT,
    OVERLAY_HEADER_SEARCH,
    OVERLAY_SHOWS_FILTER,
    OVERLAY_MOVIES_FILTER,
    OVERLAY_AUTH_MVPD_DIRECT_SIGN_IN_REDIRECT,
    OVERLAY_AUTH_MVPD_START,
    OVERLAY_AUTH_MVPD_SEARCH,
    OVERLAY_AUTH_MVPD_IFRAME,
    OVERLAY_AUTH_SUCCESS,
    OVERLAY_AUTH_UPSELL_CONFIRM,
    OVERLAY_AUTH_UPSELL_ERROR,
    OVERLAY_ALL_COLLECTIONS,
    OVERLAY_VIDEO_MODAL,
  ],
  [SITE_PLATFORM_WEB]: [
    OVERLAY_ACCOUNT,
    OVERLAY_HEADER_SEARCH,
    OVERLAY_SHOWS_FILTER,
    OVERLAY_MOVIES_FILTER,
    OVERLAY_AUTH_MVPD_DIRECT_SIGN_IN_REDIRECT,
    OVERLAY_AUTH_MVPD_START,
    OVERLAY_AUTH_MVPD_SEARCH,
    OVERLAY_AUTH_MVPD_IFRAME,
    OVERLAY_AUTH_SUCCESS,
    OVERLAY_AUTH_UPSELL_CONFIRM,
    OVERLAY_AUTH_UPSELL_ERROR,
    OVERLAY_ALL_COLLECTIONS,
    OVERLAY_VIDEO_MODAL,
  ],
  [SITE_PLATFORM_TABLET]: [
    OVERLAY_SHOWS_FILTER,
    OVERLAY_MOVIES_FILTER,
    OVERLAY_ACCOUNT,
    OVERLAY_HEADER_SEARCH,
    OVERLAY_HEADER_DROPDOWN,
    OVERLAY_SEARCH_FILTER,
    OVERLAY_SHOW_DETAIL_TABS,
    OVERLAY_SHOWS_FILTER,
    OVERLAY_MOVIES_FILTER,
    OVERLAY_AUTH_MVPD_DIRECT_SIGN_IN_REDIRECT,
    OVERLAY_AUTH_MVPD_START,
    OVERLAY_AUTH_MVPD_SEARCH,
    OVERLAY_AUTH_SUCCESS,
    OVERLAY_AUTH_MVPD_IFRAME,
    OVERLAY_AUTH_UPSELL_CONFIRM,
    OVERLAY_AUTH_UPSELL_ERROR,
    OVERLAY_ALL_COLLECTIONS,
    OVERLAY_SHOW_SEASONS_TAB,
    OVERLAY_SHOW_CLIPS_TAB,
    OVERLAY_SHOW_MORE_TAB,
    OVERLAY_LIVE_DATES,
    OVERLAY_LIVE_NETWORKS,
    OVERLAY_LIVE_CTA_OVERFLOW,
    OVERLAY_PRIMETIME_DATES,
    OVERLAY_VIDEO_MODAL,
    OVERLAY_UPCOMING_DETAIL,
  ],
  [SITE_PLATFORM_MOBILE]: [
    OVERLAY_SHOWS_FILTER,
    OVERLAY_MOVIES_FILTER,
    OVERLAY_ACCOUNT,
    OVERLAY_HEADER_SEARCH,
    OVERLAY_HEADER_DROPDOWN,
    OVERLAY_SEARCH_FILTER,
    OVERLAY_SHOW_DETAIL_TABS,
    OVERLAY_SHOWS_FILTER,
    OVERLAY_MOVIES_FILTER,
    OVERLAY_AUTH_MVPD_DIRECT_SIGN_IN_REDIRECT,
    OVERLAY_AUTH_MVPD_START,
    OVERLAY_AUTH_MVPD_SEARCH,
    OVERLAY_AUTH_SUCCESS,
    OVERLAY_AUTH_MVPD_IFRAME,
    OVERLAY_AUTH_UPSELL_CONFIRM,
    OVERLAY_AUTH_UPSELL_ERROR,
    OVERLAY_ALL_COLLECTIONS,
    OVERLAY_SHOW_SEASONS_TAB,
    OVERLAY_SHOW_CLIPS_TAB,
    OVERLAY_SHOW_MORE_TAB,
    OVERLAY_LIVE_DATES,
    OVERLAY_LIVE_NETWORKS,
    OVERLAY_LIVE_CTA_OVERFLOW,
    OVERLAY_PRIMETIME_DATES,
    OVERLAY_HOME_CTA_OVERFLOW,
    OVERLAY_VIDEO_MODAL,
    OVERLAY_UPCOMING_DETAIL,
  ],
};

export function shapeFilters(filters, onClick) {
  if (!filters) return null;
  return filters.map((filter, idx) => {
    const newFilter = filter;
    newFilter.onClickParams = {
      url: filter.url,
      name: filter.name,
      idx,
    };
    newFilter.onClick = onClick;
    return newFilter;
  });
}

/*
 * fetchList should be provided when function is bound
 */
export function onFilterClick(fetchList, onClickParams) {
  const { url, name, ignoreUpdatingUrl } = onClickParams;
  const {
    accessToken,
    deviceId,
    location: { pathname },
    params: { collectionId },
    tabs,
  } = this.props;
  this.setState({ selectedFilter: name, openDropdown: false });
  if (!ignoreUpdatingUrl) {
    const baseUrlSlug = helperGetBaseUrlSlug();
    const pageIdLocation = baseUrlSlug.split('/').length;
    const pageId = _.get(pathname.split('/'), pageIdLocation, null);
    const pageElement = pageId ? `/${pageId}` : '';
    const headline = _.get(tabs, `${[0]}.headline`);
    const defaultHeadline = encodeURIComponent(cleanString(headline));
    let collectionElement = '';
    if (pageId && pageId.toLowerCase() !== 'movies') {
      collectionElement = collectionId
        ? `/collection/${collectionId}`
        : `/collection/${defaultHeadline}`;
    }
    const filterElement = name ? `/filter/${encodeURIComponent(_.toLower(name))}` : '';
    const nextUrl = `${baseUrlSlug}${pageElement}${collectionElement}${filterElement}`;
    if (nextUrl.length > 0) browserHistory.push(`${nextUrl}/`);
  }
  if (fetchList) {
    fetchList({ accessToken, deviceId, url });
    this.setState({ showLoader: true });
  }
  animateScroll.scrollToTop();
}

export function shouldPausePlayer({ overlay, breakpointDisableScroll }) {
  const preventPauseOverlays = [OVERLAY_LIVE_DATES];
  const preventPause = _.includes(preventPauseOverlays, overlay) && !breakpointDisableScroll;
  return !preventPause;
}
